import React from 'react';

import { UserSession } from 'features/rosie';
import useUserStore from 'store/useUserStore';
import { Loader } from '@urbantxt/loader';

export default function UserSessionProvider({
  children,
}: {
  children: ({ user }: { user: UserSession }) => React.ReactNode;
}) {
  const user = useUserStore(s => s.user);

  if (user) {
    return <div>{children({ user })}</div>;
  }

  return <Loader isVisible fullscreen={false} theme="dark" />;
}
